<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.37222 13.4338H26.6278M14.3678 7L12.2357 13.4338L16.5 25.7652L20.7643 13.4338L18.6322 7M17.1552 25.5105L26.7058 13.983C26.8677 13.7876 26.9486 13.6899 26.9795 13.5809C27.0068 13.4847 27.0068 13.3828 26.9795 13.2867C26.9486 13.1777 26.8677 13.08 26.7058 12.8846L22.0861 7.30866C21.9921 7.19521 21.9451 7.13848 21.8875 7.09769C21.8365 7.06156 21.7795 7.03472 21.7192 7.01841C21.6512 7 21.5778 7 21.431 7H11.569C11.4222 7 11.3488 7 11.2808 7.01841C11.2205 7.03472 11.1635 7.06156 11.1125 7.09769C11.0549 7.13848 11.0079 7.19521 10.9139 7.30866L6.29417 12.8846C6.13231 13.08 6.05138 13.1777 6.02045 13.2867C5.99318 13.3828 5.99318 13.4847 6.02045 13.5809C6.05138 13.6899 6.13231 13.7876 6.29417 13.983L15.8448 25.5105C16.0698 25.7821 16.1823 25.9179 16.317 25.9674C16.4352 26.0109 16.5648 26.0109 16.683 25.9674C16.8177 25.9179 16.9302 25.7821 17.1552 25.5105Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
